export default __webpack_public_path__ + "static/media/date.ac825e5e.svg";